const Tracking = {
  ga_tracking_id: 'UA-17747516-4',

  gtag: function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(...arguments);
  },

  pageview: (skin, song, letters, timing) => {
    Tracking.gtag({
      'event': 'loadSongWithTheme',
      'page.theme': skin,
      'page.song': song,
      'page.timing': timing,
      'page.notation': letters ? 'letters' : 'numbers'
    });
  },

  score: (score, skin, songId, letters, timing) => {
    Tracking.gtag({
      'event': 'songPlayComplete',
      'score': score,
      'page.theme': skin,
      'page.song': songId,
      'page.timing': timing,
      'page.notation': letters ? 'letters' : 'numbers'
    })
  }
};

export default Tracking;
